import { AnySchema } from 'ajv';

import { ICreateAAOrganizationSubscriptionExtensionModel } from '../../../../models/interfaces/Subscription/AirAmbulance/CreateAAOrganizationSubscriptionExtensionModel';
import { FieldErrorMessage } from '../../../../models/FieldErrorMessage';
import { validateFormData } from '../../../../utils/validations/validateFormData';

const schema: AnySchema | any = {
  type: 'object',
  properties: {},
  dependencies: {},
  required: [],
};

export const validateExtendAASubscriptionForm = (
  data: ICreateAAOrganizationSubscriptionExtensionModel,
  additionalErrors?: FieldErrorMessage[],
) => validateFormData(data, additionalErrors, schema);
